<template>
    <div>
        <div class="row">
            <div class="col-md-7 mb-3">
                <input class="form-control custom-green-input-bg" :placeholder="`${$t('Search')}...`" type="text" v-model="term" />
            </div>
            <div class="col-md-5">
                <app-button v-if="term" native-type="button" type="warning" @click="cancelFilter" class="mt-1" small>
                    {{ $t('Cancel') }}
                </app-button>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th @click="orderBy(`name[${locale}]`)" class="pointer">
                            {{ $t('Name') }}
                            <span v-html="order_field === `name[${locale}]` ? active_sort_icon : sort_icon" />
                        </th>
                        <th @click="orderBy(`comments[${locale}]`)" class="pointer w-50">
                            {{ $t('Comments') }}
                            <span v-html="order_field === `comments[${locale}]` ? active_sort_icon : sort_icon" />
                        </th>
                        <th @click="orderBy('start_date')" class="pointer">
                            {{ $t('Start') }}
                            <span v-html="order_field === 'start_date' ? active_sort_icon : sort_icon" />
                        </th>
                        <th @click="orderBy('end_date')" class="pointer">
                            {{ $t('End') }}
                            <span v-html="order_field === 'end_date' ? active_sort_icon : sort_icon" />
                        </th>
                        <th @click="orderBy('discount_percent')" class="pointer">
                            {{ $t('Discount') }} %
                            <span v-html="order_field === 'discount_percent' ? active_sort_icon : sort_icon" />
                        </th>
                        <th>{{ $t('Image') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(offer, i) in orderedOffers" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ offer.name[locale] }}</td>
                        <td><div v-html="offer.comments[locale]"/></td>
                        <td>{{ offer.start_date | formatDate }}</td>
                        <td>{{ offer.end_date | formatDate }}</td>
                        <td>{{ offer.discount_percent }}</td>
                        <td>{{ offer.dbname ? $t('Yes') : '' }}</td>
                        <td class="p-0">
                            <div class="text-right">
                                <router-link
                                    v-if="$store.getters.canViewOffers"
                                    :to="{ name: 'specialoffers.show', params: { offer_id: offer.id } }"
                                    class="btn btn-info btn-sm text-white">
                                    {{ $t('View') }}
                                </router-link>
                                <router-link
                                    v-if="$store.getters.canEditOffers"
                                    :to="{ name: 'specialoffers.edit', params: { offer_id: offer.id } }"
                                    class="btn btn-primary btn-sm text-white ml-2">
                                    {{ $t('Edit') }}
                                </router-link>
                                <app-button v-if="$store.getters.canDeleteOffers" native-type="button" type="danger" @click="destroy(offer.id)" small>
                                    {{ $t('Delete') }}
                                </app-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import SpecialOfferService from '@services/specialOffer.service';
import { mapGetters } from 'vuex';
import orderBy from 'lodash/orderBy';

export default {
    data() {
        return {
            term: '',
            order_field: 'created_at',
            order_dir: 'desc',
            sort_icon: '<span class="mdi mdi-18px mdi-menu-swap"/>',
            special_offers: []
        };
    },
    computed: {
        ...mapGetters(['locale']),
        filteredOffers() {
            if (this.special_offers.length) {
                return this.special_offers.filter(offer => {
                    const term = this.term.toLowerCase();
                    if (offer.name[this.locale] !== null && offer.comments[this.locale] !== null) {
                        return (
                            offer.name[this.locale].toLowerCase().match(term) ||
                            offer.comments[this.locale].toLowerCase().match(term)
                        );
                    } else {
                        return true;
                    }
                });
            }
            return false;
        },
        orderedOffers() {
            return orderBy(this.filteredOffers, this.order_field, this.order_dir);
        },
        active_sort_icon() {
            if (this.order_dir === 'desc') {
                return '<span class="mdi mdi-18px mdi-menu-down"/>';
            } else {
                return '<span class="mdi mdi-18px mdi-menu-up"/>';
            }
        }
    },
    methods: {
        orderBy(field) {
            this.order_field = field;
            if (this.order_dir === 'desc') {
                this.order_dir = 'asc';
            } else {
                this.order_dir = 'desc';
            }
        },
        cancelFilter() {
            this.term = '';
        },
        getSpecialOffers() {
            SpecialOfferService.specialOffers().then(res => (this.special_offers = res));
        },
        destroy(offerId) {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            SpecialOfferService.destroy(offerId).then(res => {
                const index = this.special_offers.findIndex(off => off.id === offerId);
                this.special_offers.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    created() {
        this.getSpecialOffers();
    }
};
</script>
